<div class="card-header">
  <app-breadcrumb currentPage="betaling mislukt"></app-breadcrumb>
</div>
<div class="card-body">
  <h2>onsuccesvolle betaling</h2>
  <p>
    uw betaling was onsuccesvol. Probeer het nogmaals of neem contact met ons op door te mailen naar
    <a href="mailto:info@reveon.nl" class="link">info@reveon.nl</a>
    of via het contactformulier.
  </p>
  <div class="spacer-small"></div>
  <a class="btn user btn-left" href="https://www.reveon.nl/contactformulier/" >neem contact op via het contactformulier</a>

  <div class="btn btn-left"
       *ngIf="reportInfo"
       [ngClass]="reportInfo?.type"
       (click)="toReport()">
    ga terug naar de {{ reportService.getReportName(this.reportInfo.type) }}
  </div>

  <div class="spacer"></div>
  <span style="font-size: 130px; line-height: 100%;">😟</span>
</div>
